export const APP_TITLE = 'myrota';

export const defaultDateTimeFormat = 'DD.MM.YYYY HH:mm';
export const defaultDateTimeRangeFormat = 'DD-MM-YYYY HH:mm';
export const defaultDateFormat = 'DD-MM-YYYY';
export const defaultPage = 0;
export const defaultPageSize = 50;
export const defaultDutiesPageSize = 30;
export const defaultRequestsPageSize = 50;
export const defaultEnquiryPageSize = 30;
export const defaultPinboardPageSize = 30;
export const defaultOrder = 0; // prod build is too optimized to recognize Order.Ascending
export const defaultError = 'Server error';
export const dateRangeDelimiter = '|';

export const storeLinkAndroid = 'market://details?id=at.rota.myrota';
export const storeLinkIos = 'itms-apps://itunes.apple.com/app/id1280854705';
